import { computed, unref, type MaybeRefOrGetter } from 'vue'

/**
 * Detects whether a URL points to a private NetBird endpoint.
 *
 * NetBird endpoints require an additional TLS certificate, so both the tenant
 * and the customer level microtech pages reveal the PEM field based on this.
 */
export const isNetbirdHost = (url?: string | null): boolean => {
  if (!url) return false
  try {
    const urlStr = url.includes('://') ? url : `https://${url}`
    const hostname = new URL(urlStr).hostname.toLowerCase()
    return hostname === 'netbird.cloud' || hostname.endsWith('.netbird.cloud')
  } catch {
    return false
  }
}

/**
 * Reactive variant of {@link isNetbirdHost} for use inside components.
 */
export const useNetbirdUrl = (url: MaybeRefOrGetter<string | undefined | null>) => {
  const isNetbirdUrl = computed(() =>
    isNetbirdHost(typeof url === 'function' ? url() : unref(url)),
  )

  return { isNetbirdUrl }
}
